import { Component, OnInit, Inject } from '@angular/core';
import { MasterData } from '../../models/MasterData';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../service/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { OnboardingService } from '../../service/onboarding.service';
import { DepartmentsService } from '../../service/departments.service';
import { EmployeeService } from '../../service/employee.service';

@Component({
  selector: 'app-techgroup-dialog',
  templateUrl: './techgroup-dialog.component.html',
  styleUrls: ['./techgroup-dialog.component.css']
})
export class TechgroupDialogComponent implements OnInit {
  title: string;
  message: any;
  masterdata: MasterData;
  error: any;
  empCode: number;
  techGroupList: any[];
  techbool: Boolean = false;
  TechGroupForm: FormGroup;
  constructor(private toastr: ToastrService, private userService: UserService, public dialogRefTech: MatDialogRef<TechgroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TechGroupDialog, private formBuilder: FormBuilder, private hrSvc: OnboardingService, private _service: EmployeeService, private deptSvc: DepartmentsService) {
    dialogRefTech.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
    this.masterdata = new MasterData();
    this.getTechGroup();
    this.empCode = this.userService.getEmpCode();
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.TechGroupForm = this.formBuilder.group({
      TechGroupName: ['', [Validators.required, Validators.pattern(nonWhitespaceRegExp)]],
    });
  }


  getTechGroup() {
    this.deptSvc.getMasterGroupByCategory('TechGroup').subscribe((data: any) => {
      this.techGroupList = data;
    });
  }
  get f() { return this.TechGroupForm.controls; }

  onConfirm(): void {
    if (!this.TechGroupForm.invalid) {
      this.masterdata.UpdatedBy = this.empCode.toString();
      this.techGroupList.forEach(item => {
        if (item.GroupName.toLowerCase() == this.masterdata.GroupName.toLowerCase()) {
          this.techbool = true;
        }
      });
      if (this.techbool == false) {

        this._service.SaveMasterGroup(this.masterdata).subscribe(data => {
          this.dialogRefTech.close(this.masterdata);
        }, error => this.error = error)
      }
      else {
        this.toastr.warning("Same Tech Group exists");
        this.masterdata.GroupName = null;
        this.techbool = false;
      }
    }
    else {
      return;
    }
  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRefTech.close(false);
  }
}
export class TechGroupDialog {

  constructor(public title: string, public message: any) {

  }
}
